/** The drop dashboard design's palette (workbench/backlog/feature_watchdog/drop_dashboard.txt). */
export const colors = {
    canvas: "#F5F6F8",
    surface: "#FFFFFF",
    ink: "#0F1419",
    muted: "#5A6473",
    subtle: "#8B94A3",
    line: "#E4E7EC",
    lineStrong: "#D0D5DD",
    accent: "#3B5BDB",
    accentSoft: "#EEF2FF",
    critical: "#D92D20",
    criticalSoft: "#FEF3F2",
    criticalInk: "#B42318",
    warning: "#DC6803",
    warningSoft: "#FFFAEB",
    warningInk: "#B54708",
    caution: "#CA8A04",
    cautionSoft: "#FEFCE8",
    cautionInk: "#854D0E",
    positive: "#079455",
    positiveSoft: "#ECFDF3",
    positiveInk: "#067647",
    chartSubtle: "#98A2B3",
    algorithm: "#7A5AF8",
    pageChange: "#0E7090",
};

export const causeColors = {
    Errored: "#D92D20",
    Indexability: "#DC6803",
    Orphaned: "#6941C6",
    Content: "#0E9384",
    "Algorithm update": "#7A5AF8",
    Technical: "#D92D20",
    "Ranking loss": "#DC6803",
    "SERP feature": "#0E9384",
    Cannibalization: "#CA8A04",
    International: "#3B5BDB",
};
